export const WORK_CALENDAR_EXCEPTION = 'WorkCalendarException';
export const WorkCalendarExceptionKindValues = [
    'nonworking',
    'working',
];
/** Grid/form labels for `kind` — never show the raw enum. */
export const WORK_CALENDAR_EXCEPTION_KIND_LABELS = {
    nonworking: 'Não trabalhável',
    working: 'Trabalhável',
};
export function workCalendarExceptionKindLabel(kind) {
    return WORK_CALENDAR_EXCEPTION_KIND_LABELS[kind];
}
//# sourceMappingURL=work-calendar-exception.js.map